/* unplugin-vue-components disabled */import { render } from "./top-nav.vue?vue&type=template&id=33876084&scoped=true"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"

import "./top-nav.vue?vue&type=style&index=0&id=33876084&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33876084"]])

export default __exports__